module.exports = __webpack_public_path__ + "static/media/uploadPlaceholder.ff7c6622.svg";